<ng-container *appTranslate="let t">
  <new-ui-error-page errorCode="404" [errorMessage]="t('notFound.title')" [errorDescription]="t('notFound.message')">
    <a pButton [text]="true" severity="warn" [routerLink]="['/']">{{ t("home.title") }}</a>
  </new-ui-error-page>
</ng-container>
